import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      chatbot: {
        DELETE_SESSION: 'Delete Session',
        DELETE_SESSION_DES:
          'Are you sure you want to delete the session "%{sessionName}" ?',
        FIINGATE_ASSISTANT: 'FiinGate Assistant',
        HELLO_CHATBOT_1: 'Hello %{name}!',
        HELLO_CHATBOT_1_GREETING: 'Hello,',
        HELLO_CHATBOT_2:
          'FiinGate Assistant is ready to support your financial analysis.',
        NEW_CHAT: 'New chat',
        SESSION_HISTORY: 'Session history',
        ASK_FIINGATE_ASSISTANT: 'Ask FiinGate Assistant',
        PLACEHOLDER_ASK: `Ask about this company's financial statement or analysis`,
        SEARCH: 'Search',
        ASK_FIIN_GATE_ASSISTANT: 'Ask FiinGate Assistant',
        THINKING: 'FiinGate Assistant is thinking',
        CONNECTION_ERROR:
          'Unable to connect to server. Please try again later.',
        SEND_MESSAGE_ERROR:
          'Unable to send message. Please check your connection and try again.',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      chatbot: {
        DELETE_SESSION: 'Xóa cuộc trò chuyện',
        DELETE_SESSION_DES: 'Bạn muốn xóa cuộc trò chuyện "%{sessionName}" ?',
        FIINGATE_ASSISTANT: 'FiinGate Assistant',
        HELLO_CHATBOT_1: 'Xin chào %{name}!',
        HELLO_CHATBOT_1_GREETING: 'Xin chào,',
        HELLO_CHATBOT_2:
          'FiinGate Assistant đã sẵn sàng hỗ trợ bạn trong việc phân tích tài chính.',
        NEW_CHAT: 'Cuộc hội thoại mới',
        SESSION_HISTORY: 'Lịch sử trò chuyện',
        ASK_FIINGATE_ASSISTANT: 'Ask FiinGate Assistant',
        PLACEHOLDER_ASK:
          'Nhập câu hỏi về báo cáo hoặc phân tích tài chính của công ty',
        SEARCH: 'Tìm kiếm',
        ASK_FIIN_GATE_ASSISTANT: 'Hỏi FiinGate Assistant',
        THINKING: 'FiinGate Assistant đang suy nghĩ',
        CONNECTION_ERROR:
          'Không thể kết nối đến máy chủ. Vui lòng thử lại sau.',
        SEND_MESSAGE_ERROR:
          'Không thể gửi tin nhắn. Vui lòng kiểm tra kết nối và thử lại.',
      },
    },
  }),
)
